module.exports = __webpack_public_path__ + "static/img/4.a080d762.jpg";